import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BillingService } from '../../../financials/services/billing.service';
import { Observable } from 'rxjs';
import { stripeAccount } from '../../../financials/model/stripe-account.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'clp-dashboard',
    styleUrls: ['./dashboard.component.scss'],
    templateUrl: './dashboard.component.html',
    imports: [
        RouterModule,
        TranslateModule
    ],
    providers: [
        BillingService
    ]
})

export class DashboardComponent implements OnInit {
    private translate = inject(TranslateService);
    private billingService = inject(BillingService);
    stripeAccount$!: Observable<stripeAccount>;
    public showStripeMessage : boolean = false;

    ngOnInit(): void {
        this.stripeAccount$ = this.billingService.getStripeAccount();
        this.stripeAccount$.subscribe(account => {
            if (account === undefined || account === null) {
                this.showStripeMessage = true;
            }
        })
    }
}
